"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController = /** @class */ (function () {
    function BaseController(reset) {
        if (reset === void 0) { reset = true; }
        this._ID = 2;
        this._CALLBACK = [];
        if (reset) {
            this.ResetData();
        }
    }
    BaseController.prototype.Update = function (channel) {
        if (!channel) {
            this.NotifyAll(this.DATA);
        }
        else {
            this.NotifyChannel(channel, this.DATA);
        }
    };
    BaseController.prototype.SetData = function (data) {
        this.DATA = data;
        this.Update();
    };
    BaseController.prototype.GetData = function () {
        return this.DATA;
    };
    BaseController.prototype.Subscribe = function (channel, callback) {
        this._ID++;
        this._CALLBACK.push({ ch: channel, id: this._ID, cb: callback });
        return this._ID;
    };
    BaseController.prototype.RemoveCallBack = function (idx) {
        var rest = this._CALLBACK.slice(idx + 1);
        this._CALLBACK.length = idx;
        return this._CALLBACK.push.apply(this._CALLBACK, rest);
    };
    BaseController.prototype.UnSubscribe = function (ID) {
        for (var idx = 0; idx < this._CALLBACK.length; idx++) {
            if (this._CALLBACK[idx]) {
                if (this._CALLBACK[idx].id === ID) {
                    this.RemoveCallBack(idx);
                    return true;
                }
            }
        }
        return false;
    };
    BaseController.prototype.NotifyAll = function (data) {
        for (var idx = 0; idx < this._CALLBACK.length; idx++) {
            if (this._CALLBACK[idx]) {
                this._CALLBACK[idx].cb(this._CALLBACK[idx].id, data);
            }
        }
    };
    BaseController.prototype.NotifyChannel = function (channel, data, action) {
        for (var idx = 0; idx < this._CALLBACK.length; idx++) {
            if (this._CALLBACK[idx]) {
                if (this._CALLBACK[idx].ch === channel) {
                    this._CALLBACK[idx].cb(this._CALLBACK[idx].id, data);
                }
            }
        }
    };
    return BaseController;
}());
exports.BaseController = BaseController;



//////////////////
// WEBPACK FOOTER
// ./src/shared/controllers/BaseController.ts
// module id = 1
// module chunks = 0